module.exports = __webpack_public_path__ + "static/GKF2-9dcc18a8b628320e5731cfabd5a1d527.jpg";